module.exports = __webpack_public_path__ + "media/12ingredient.6d347d67.mp3";